import { pages } from './pages';

const definedObjTypes = pages.map((item) => {
  return item.name;
});

export function check(name) {
  if (definedObjTypes.indexOf(name) === -1) {
    // eslint-disable-next-line
    console.error(`未定义页面 obj_type: ${name}；请查看 assets/util-lib/statistics/sa/pages.js`);
    return false;
  }
  return true;
}
